import { render, staticRenderFns } from "./teamNews.vue?vue&type=template&id=2c4784fd&scoped=true"
import script from "./teamNews.vue?vue&type=script&lang=js"
export * from "./teamNews.vue?vue&type=script&lang=js"
import style0 from "./teamNews.vue?vue&type=style&index=0&id=2c4784fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4784fd",
  null
  
)

export default component.exports